module.exports = __webpack_public_path__ + "static/media/arrow-right-small.fa7054e9.svg";